import * as React from 'react'
import { withSelectedCompany } from '@/modules/shared/hocs/withSelectedCompany'
import GenericErrorPresenter, {
  GenericErrorPresenterDispatchProps,
  GenericErrorPresenterStateProps,
  GenericErrorPresenterOwnProps,
} from 'app/components/application/genericError'
import { useGenericErrorStore } from '@/modules/shared/stores/genericErrorStore'

const Presenter = GenericErrorPresenter as any

/**
 * `error` przychodzi z zustanda. Zostal sam odczyt - `connect` nie mial juz czego
 * mapowac, a stal tu tylko po to, zeby komponent w ogole dostal propsy.
 */
const GenericErrorPresenterContainer: React.FC<
  GenericErrorPresenterOwnProps
> = (props) => {
  const error = useGenericErrorStore((s) => s.error)
  return <Presenter {...(props as any)} error={error} />
}

export default withSelectedCompany(GenericErrorPresenterContainer as any)
